module.exports = __webpack_public_path__ + "static/media/Coffee_at_home_credit_Getty_Images_mobile.222afa03.jpg";